import { getStatementSummary } from '../../utils/format/credit-card-statement-summary';

// Present the full statement separately from the searchable transaction table.
const StatementSummary = ({ statement, t }) => {
  if (!statement) return null;
  const summary = getStatementSummary(statement, t.lang);
  const progress = t.read('cc_transactions.summary.progress')
    .replace('{matched}', summary.matched)
    .replace('{total}', summary.count)
    .replace('{submitted}', summary.submitted);

  return (
    <dl className='credit-transactions-summary'>
      <div>
        <dt>{t.read('cc_transactions.summary.card')}</dt>
        <dd>
          <span className='credit-transactions-summary__value'>{statement.card_label || '—'}</span>
          <span className='credit-transactions-summary__detail'>
            {[summary.maskedCard, statement.card_type].filter(Boolean).join(' · ')}
          </span>
        </dd>
      </div>
      <div>
        <dt>{t.read('cc_transactions.summary.total')}</dt>
        <dd>
          <span className='credit-transactions-summary__value'>{summary.total}</span>
          {summary.currency && <span className='credit-transactions-summary__detail'>{summary.currency}</span>}
        </dd>
      </div>
      <div>
        <dt>{t.read('cc_transactions.sub-title')}</dt>
        <dd>
          <span className='credit-transactions-summary__value'>{summary.count}</span>
          <span className='credit-transactions-summary__detail'>{progress}</span>
        </dd>
      </div>
    </dl>
  );
};

export default StatementSummary;
